// Diagnose Mode: Standalone (Mode 1), VDR-invoked (Mode 2), and VDR multi-session (Mode 3). Shared route/param constants.
export const ROUTES = {
  SELECT_SOLUTIONS: 'select-solutions',
  VIEW_SUMMARY: 'view-summary',
  SELECT_CHALLENGES: 'select-challenges',
  SOLUTION_SELECTION: 'solution-selection',
  WORKFLOW: 'workflow',
  DIAGNOSIS_COMPLETE: 'diagnosis-complete',
  // Mode 3 only. Landing route: /pid/:projectId
  MODE3_PROJECT: 'pid',
};

export const PARAMS = {
  ExternalId: 'eid',
  SessionId: 'sid',
  DiagnosisId: 'diagnosisId',
  Source: 'source',
  // Mode 3 only. Internal Guid returned by /vdr/project/initialize.
  ProjectId: 'projectId',
};

export const LOCAL_VARS = {
  SelectedPSL: 'SelectedPSL',
};

export const SOURCE = {
  VDR: 'vdr',
  DEFAULT: '',
};
